const local = {
  API: {
    AUTH: 'https://localhost:44396/api',
    DATA: 'https://localhost:44396/api'

    //  DATA: 'http://localhost:64179/api/'
  },
  OPAYO: {
    URL: 'https://c00e-93-107-8-139.ngrok-free.app/api/payment/handleASCNotification',
    SCRIPT: 'https://sandbox.opayo.eu.elavon.com/api/v1/js/sagepay.js'
  }
}

const dev = {
  API: {
    AUTH: 'https://localhost:44396/api',
    DATA: 'https://localhost:44396/api',
  },
  OPAYO: {
    // URL: 'https://5727-93-107-8-139.ngrok-free.app/api/payment/handleASCNotification',
    URL: 'https://c00e-93-107-8-139.ngrok-free.app/api/payment/handleASCNotification',
    SCRIPT: 'https://sandbox.opayo.eu.elavon.com/api/v1/js/sagepay.js'
  }
}

const uat = {
  API: {
    AUTH: 'https://lms-motorsportireland-api-uat.azurewebsites.net/api',
    DATA: 'https://lms-motorsportireland-api-uat.azurewebsites.net/api'
  },
  OPAYO: {
    URL: 'https://lms-motorsportireland-api-uat.azurewebsites.net/api/payment/handleASCNotification',
    SCRIPT: 'https://sandbox.opayo.eu.elavon.com/api/v1/js/sagepay.js'
  }
}

const prod = {
  API: {
    AUTH: 'https://lms-motorsportireland-api-geahakb2hneyc5en.northeurope-01.azurewebsites.net/api',
    DATA: 'https://lms-motorsportireland-api-geahakb2hneyc5en.northeurope-01.azurewebsites.net/api'
  },
  OPAYO: {
    URL: 'https://lms-motorsportireland-api-geahakb2hneyc5en.northeurope-01.azurewebsites.net/api/payment/handleASCNotification',
    SCRIPT: 'https://live.opayo.eu.elavon.com/api/v1/js/sagepay.js'
  }
}

const config = process.env.REACT_APP_STAGE === 'prod' ? prod
  : process.env.REACT_APP_STAGE === 'uat' ? uat
    : process.env.REACT_APP_STAGE === 'dev' ? dev
      : local;

const API_URL = config.API.DATA;
const AUTH_URL = config.API.AUTH;
const OPAYO_URL = config.OPAYO.URL;
const OPAYO_SCRIPT = config.OPAYO.SCRIPT;

export { API_URL, AUTH_URL, OPAYO_URL, OPAYO_SCRIPT };
export default config;
